import RestApiModel from "@/api/Model/RestApiModel";
import api from "../index";

class CompanyAddressPhoneNumber extends RestApiModel {
  static getResourceEndpoint() {
    return '/companies/addresses/phone-numbers';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

  static setPrimary(id ) {
    return api.patch(this.getResourceIdEndpoint(id, 'set-as-primary'));
  }

}

export default CompanyAddressPhoneNumber;
